export function isIncludesPath(key: string, path: string) {
  const cleanKey = key.replace(/^[a-z]{2}\//, '')
  const cleanPath = path.replace(/^[a-z]{2}\//, '').replace(/\/$/, '')
  return cleanPath.includes(cleanKey)
}
